import moment from "moment"
import { CustomMultiSelectModel } from "../../../components/CustomMultiSelect"
import { ColumnChooserModel } from "../../common/ColumnChooserModel"
import { ColumnFilterModel } from "../../common/ColumnFilterModel"

export interface GetIdleReportListPagingAndFilterRequest {
    searchTerm: string
    skip: number
    take: number
    startDate: string
    endDate: string
    selectedDevices: CustomMultiSelectModel[]
    selectedDrivers: CustomMultiSelectModel[]
    columnChooser: ColumnChooserModel[] | undefined,
    currentPage: number
    /** Kolon başlıklarının altındaki filtreler. */
    columnFilters: ColumnFilterModel[]
}

export const initialGetIdleReportListPagingAndFilterRequest: GetIdleReportListPagingAndFilterRequest = {
    searchTerm: '',
    skip: 0,
    take: 50,
    currentPage: 1,
    columnChooser: undefined,
    startDate: moment().format('YYYY-MM-DD'),
    endDate: moment().format('YYYY-MM-DD'),
    selectedDevices: [],
    selectedDrivers: [],
    columnFilters: []
}